function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg214SanMarino(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.006 512.006",
    style: {
      enableBackground: "new 0 0 512.006 512.006"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.003,
    y: 0.017,
    style: {
      fill: "#338AF3"
    },
    width: 512,
    height: 511.989
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "512.003,0 512.003,250.031 0.003,256.258 0.003,0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA544"
    },
    d: "M338.566,191.524l-82.563,82.563l-82.563-82.563c-10.676,15.85-16.915,34.926-16.915,55.433v27.13  c0,43.563,28.149,80.672,67.212,94.103c-5.214,10.218-4.334,22.971,3.306,32.505c10.146-8.132,20.653-16.551,29.564-23.691  c8.912,7.141,19.417,15.559,29.564,23.691c7.73-9.646,8.545-22.589,3.125-32.867c38.529-13.724,66.187-50.56,66.187-93.742v-27.13  C355.481,226.45,349.242,207.373,338.566,191.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M256.003,346.435c-39.893,0-72.348-32.455-72.348-72.348v-27.13  c0-39.893,32.455-72.348,72.348-72.348s72.348,32.455,72.348,72.348v27.13C328.351,313.98,295.895,346.435,256.003,346.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#338AF3"
    },
    d: "M301.22,274.087v-27.13c0-24.933-20.284-45.217-45.217-45.217s-45.217,20.284-45.217,45.217v27.13  l45.217,9.043L301.22,274.087z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA544"
    },
    d: "M210.785,274.087L210.785,274.087c0,24.933,20.284,45.217,45.217,45.217s45.217-20.284,45.217-45.217  l0,0H210.785z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M310.264,174.609c0-14.984-12.147-27.13-27.13-27.13c-6.951,0-13.286,2.616-18.087,6.913v-15.957  h9.043v-18.087h-9.043v-9.043h-18.087v9.043h-9.043v18.087h9.043v15.957c-4.801-4.297-11.136-6.913-18.087-6.913  c-14.984,0-27.13,12.147-27.13,27.13c0,8.033,3.495,15.249,9.043,20.217v15.957h90.435v-15.957  C306.769,189.857,310.264,182.642,310.264,174.609z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg214SanMarino);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMi4wMDYgNTEyLjAwNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyLjAwNiA1MTIuMDA2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxyZWN0IHg9IjAuMDAzIiB5PSIwLjAxNyIgc3R5bGU9ImZpbGw6IzMzOEFGMzsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTExLjk4OSIvPgo8cG9seWdvbiBzdHlsZT0iZmlsbDojRjBGMEYwOyIgcG9pbnRzPSI1MTIuMDAzLDAgNTEyLjAwMywyNTAuMDMxIDAuMDAzLDI1Ni4yNTggMC4wMDMsMCAiLz4KPHBhdGggc3R5bGU9ImZpbGw6IzZEQTU0NDsiIGQ9Ik0zMzguNTY2LDE5MS41MjRsLTgyLjU2Myw4Mi41NjNsLTgyLjU2My04Mi41NjNjLTEwLjY3NiwxNS44NS0xNi45MTUsMzQuOTI2LTE2LjkxNSw1NS40MzN2MjcuMTMgIGMwLDQzLjU2MywyOC4xNDksODAuNjcyLDY3LjIxMiw5NC4xMDNjLTUuMjE0LDEwLjIxOC00LjMzNCwyMi45NzEsMy4zMDYsMzIuNTA1YzEwLjE0Ni04LjEzMiwyMC42NTMtMTYuNTUxLDI5LjU2NC0yMy42OTEgIGM4LjkxMiw3LjE0MSwxOS40MTcsMTUuNTU5LDI5LjU2NCwyMy42OTFjNy43My05LjY0Niw4LjU0NS0yMi41ODksMy4xMjUtMzIuODY3YzM4LjUyOS0xMy43MjQsNjYuMTg3LTUwLjU2LDY2LjE4Ny05My43NDJ2LTI3LjEzICBDMzU1LjQ4MSwyMjYuNDUsMzQ5LjI0MiwyMDcuMzczLDMzOC41NjYsMTkxLjUyNHoiLz4KPHBhdGggc3R5bGU9ImZpbGw6I0ZGREE0NDsiIGQ9Ik0yNTYuMDAzLDM0Ni40MzVjLTM5Ljg5MywwLTcyLjM0OC0zMi40NTUtNzIuMzQ4LTcyLjM0OHYtMjcuMTMgIGMwLTM5Ljg5MywzMi40NTUtNzIuMzQ4LDcyLjM0OC03Mi4zNDhzNzIuMzQ4LDMyLjQ1NSw3Mi4zNDgsNzIuMzQ4djI3LjEzQzMyOC4zNTEsMzEzLjk4LDI5NS44OTUsMzQ2LjQzNSwyNTYuMDAzLDM0Ni40MzV6Ii8+CjxwYXRoIHN0eWxlPSJmaWxsOiMzMzhBRjM7IiBkPSJNMzAxLjIyLDI3NC4wODd2LTI3LjEzYzAtMjQuOTMzLTIwLjI4NC00NS4yMTctNDUuMjE3LTQ1LjIxN3MtNDUuMjE3LDIwLjI4NC00NS4yMTcsNDUuMjE3djI3LjEzICBsNDUuMjE3LDkuMDQzTDMwMS4yMiwyNzQuMDg3eiIvPgo8cGF0aCBzdHlsZT0iZmlsbDojNkRBNTQ0OyIgZD0iTTIxMC43ODUsMjc0LjA4N0wyMTAuNzg1LDI3NC4wODdjMCwyNC45MzMsMjAuMjg0LDQ1LjIxNyw0NS4yMTcsNDUuMjE3czQ1LjIxNy0yMC4yODQsNDUuMjE3LTQ1LjIxNyAgbDAsMEgyMTAuNzg1eiIvPgo8cGF0aCBzdHlsZT0iZmlsbDojRkZEQTQ0OyIgZD0iTTMxMC4yNjQsMTc0LjYwOWMwLTE0Ljk4NC0xMi4xNDctMjcuMTMtMjcuMTMtMjcuMTNjLTYuOTUxLDAtMTMuMjg2LDIuNjE2LTE4LjA4Nyw2LjkxM3YtMTUuOTU3ICBoOS4wNDN2LTE4LjA4N2gtOS4wNDN2LTkuMDQzaC0xOC4wODd2OS4wNDNoLTkuMDQzdjE4LjA4N2g5LjA0M3YxNS45NTdjLTQuODAxLTQuMjk3LTExLjEzNi02LjkxMy0xOC4wODctNi45MTMgIGMtMTQuOTg0LDAtMjcuMTMsMTIuMTQ3LTI3LjEzLDI3LjEzYzAsOC4wMzMsMy40OTUsMTUuMjQ5LDkuMDQzLDIwLjIxN3YxNS45NTdoOTAuNDM1di0xNS45NTcgIEMzMDYuNzY5LDE4OS44NTcsMzEwLjI2NCwxODIuNjQyLDMxMC4yNjQsMTc0LjYwOXoiLz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };